import React from 'react';
import {useTranslation} from 'react-i18next';

import {Layout} from '@phonectas/unifon-ui-kit';
import TextWithLabel from 'common/components/TextWithLabel';
import {formatInfo, getSatisfactionDetails} from 'utils/div';
import {Account} from 'common/types/store/threeSixtyTypes';

interface Props {
	data: Account | null;
}

const CustomerCompanyInfo: React.FC<Props> = ({data}) => {
	const [t] = useTranslation();
	const accDeatails = data?.account_details;
	const satisfaction = getSatisfactionDetails(accDeatails?.satisfaction_rating ?? null);
	const toStringOrUndefined = (value: string | number | null | undefined) =>
		value != null ? String(value) : undefined;

	return (
		<Layout direction="row" fullWidth style={{padding: '16px', justifyContent: 'space-evenly'}}>
			<Layout direction="column" gap="md" style={{margin: '0 auto 0 0'}}>
				<TextWithLabel truncated label={t('Group agreement')} text={formatInfo(accDeatails?.group_agreement)} />
				<TextWithLabel label={t('Org. number')} text={formatInfo(accDeatails?.vat_number)} />
			</Layout>
			<Layout direction="column" gap="md" style={{margin: '0 auto 0 0'}}>
				<TextWithLabel truncated label={t('Trade code')} text={formatInfo(accDeatails?.industry?.desc)} />
				<TextWithLabel label={t('Number of employees')} text={formatInfo(toStringOrUndefined(accDeatails?.employers_count))} />
			</Layout>
			<Layout direction="column" gap="md" style={{margin: '0 auto 0 0'}}>
				<TextWithLabel label={t('Provider code')} text={formatInfo(toStringOrUndefined(accDeatails?.provider_code))} />
				<TextWithLabel label={t('Sales rep.')} text={formatInfo(accDeatails?.sales_rep)} />
			</Layout>
			<Layout direction="column" gap="md" style={{margin: '0 auto 0 0'}}>
				<TextWithLabel
					label={t('Satisfaction')}
					textColor={satisfaction.colorCode}
					text={satisfaction.text}
					toUpperCase
				/>
			</Layout>
		</Layout>
	);
}

export default CustomerCompanyInfo;
